import Nullstack from 'nullstack';
export default function IconZoomPan({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-zoom-pan",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M17 17l-2.5 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M10 5l2 -2l2 2"
  }), "   ", Nullstack.element("path", {
    d: "M19 10l2 2l-2 2"
  }), "   ", Nullstack.element("path", {
    d: "M5 10l-2 2l2 2"
  }), "   ", Nullstack.element("path", {
    d: "M10 19l2 2l2 -2"
  }), " ");
}